import React from 'react';
import {LoadingDialog} from '../../../../_metronic/_partials/controls';
import {useBankStatementsContext} from '../context/BankStatementsContext';

export function BankStatementsLoadingDialog() {
  const {loading} = useBankStatementsContext();

  return <LoadingDialog isLoading={loading}/>;
}
